export default {
  xxl: 40,
  xl: 30,
  lg: 22,
  md: 16,
  sm: 12,
  xs: 8,
  xxs: 4,
};
